module.exports = __webpack_public_path__ + "img/01.4fdc60bc.jpg";